import { useEffect, useState } from 'react'
import Loader from '@/react-components/components/lottie/loading-animation'
import Summary from '../../components/summary'
import { Section } from './types'
import {
  PageWrapper,
  StickyHeader,
  TitleWrapper,
  LandingPageTitle,
  LandingPageDescription,
} from './styles'
import { GoodlordReferencingLogo } from '../../components/goodlord-referencing-logo'
import { progressToOutstandingAction, progressToSectionData } from './utils'
import { getSubjectSummary } from '../../../service/api'
import { useSelector } from 'react-redux'
import type { RootState } from '../../../store/redux-store'
import { track } from '@/common/utils'
import { Recommendation } from '../../../types/types'

const LandingPage = () => {
  const [sectionData, setSectionData] = useState<Section[] | undefined>(undefined)
  const [outstandingAction, setOutstandingAction] = useState<Recommendation | undefined>(
    undefined,
  )

  const [scrollPosition, setScrollPosition] = useState(0)

  const handleScroll = () => {
    const position = window.scrollY
    setScrollPosition(position)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const jwtToken = useSelector((state: RootState) => state.user.jwtToken)

  useEffect(() => {
    let cancelled = false
    const token = jwtToken ?? localStorage.getItem('token') ?? ''

    getSubjectSummary(token)
      .then(response => {
        if (cancelled || response === undefined) {
          return
        }
        track('Summary page loaded', {})
        const progress = JSON.parse(JSON.stringify(response.progress))
        setSectionData(progressToSectionData(progress))
        setOutstandingAction(progressToOutstandingAction(progress))
      })
      .catch(e => {
        if (!cancelled) {
          console.error(e)
        }
      })

    return () => {
      cancelled = true
    }
  }, [jwtToken])

  return (
    <PageWrapper
      onScroll={e => {
        const element = e.target as HTMLElement
        setScrollPosition(element.scrollTop)
      }}
    >
      <StickyHeader $isExpanded={scrollPosition < 100}>
        <GoodlordReferencingLogo />
      </StickyHeader>
      {sectionData !== undefined ? (
        <>
          <TitleWrapper>
            <LandingPageTitle>What you'll need</LandingPageTitle>
            <LandingPageDescription>
              Take a few minutes to read this first. Getting your documents together now is
              much quicker than stopping halfway through.
            </LandingPageDescription>
          </TitleWrapper>
          <Summary sections={sectionData} outstandingAction={outstandingAction} />
        </>
      ) : (
        <Loader />
      )}
    </PageWrapper>
  )
}

export default LandingPage
